import { render, staticRenderFns } from "./DataLogCollect.vue?vue&type=template&id=24ac7408&scoped=true&"
import script from "./DataLogCollect.vue?vue&type=script&lang=js&"
export * from "./DataLogCollect.vue?vue&type=script&lang=js&"
import style0 from "./DataLogCollect.vue?vue&type=style&index=0&id=24ac7408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac7408",
  null
  
)

export default component.exports